import moment from 'moment';
import React from 'react';
import { PlayData } from '../../../../queries/ats/playback/api';
import { useAsset } from '../../../../queries/ats/titles/hooks';
import { ProgramPlaybackOption } from '../../../../queries/ats/titles/types/playback-option';
import { EpisodeTitle, MovieTitle, ProgramTitle } from '../../../../queries/ats/titles/types/title';
import { ClientPlayer } from '../client-player/client-player';
import { PlayerLoadingSpinner } from '../player-loading-spinner';
import { ProgramPlayerThirdPartyCatchupDeeplink } from './program-third-party-catchup-deeplink';
import { getPreferredProgramSource } from './utils';

interface ProgramPlayerProps {
  data: PlayData;
  title: EpisodeTitle | MovieTitle | ProgramTitle;
  playbackOption: ProgramPlaybackOption;
  position: number | undefined;
  reportConsumption: (position: number) => void;
  stopConsumption: (position: number) => void;
}

export function ProgramPlayer({ title, ...rest }: ProgramPlayerProps) {
  const { data: asset, isLoading } = useAsset({
    id: title.masterId,
    orderByServiceType: 'program',
    orderByProviderId: undefined,
  });

  if (isLoading) {
    return <PlayerLoadingSpinner />;
  }

  if (asset === undefined) {
    return <ClientPlayer title={title} {...rest} />;
  }

  if (asset.type === 'series') {
    return <ClientPlayer title={title} {...rest} />;
  }

  const source = getPreferredProgramSource(asset);

  const now = moment();
  const thirdPartyTreshold = moment(source.endTime).add(15, 'minutes');

  if (now.isAfter(thirdPartyTreshold) && source.relatedSource && source.relatedSource.type === 'thirdparty') {
    return (
      <ProgramPlayerThirdPartyCatchupDeeplink
        asset={asset}
        source={source.relatedSource}
        channelId={source.channelId}
      />
    );
  }

  return <ClientPlayer title={title} {...rest} />;
}
